import React, { useEffect, useState } from 'react';
import styles from '../../styles/ReporteCalificacionesStyles/ReporteCalificaciones.module.css';
import { getCycles } from '../../api/ciclosEscolares';
import { getCampus } from '../../api/campus';

/**
 * Filtros para la pantalla de Materias Equivalentes a Revalidar.
 *
 * Props:
 *  - filters: { ciclo_escolar, id_campus, matricula }
 *  - onChange(key, value)
 *  - onBuscar()
 *  - loading: boolean
 *  - onContextResolved({ ciclo, campus, matricula })  // opcional
 */
function FiltrosRevalidacion({ filters, onChange, onBuscar, loading, onContextResolved }) {
  const [ciclos, setCiclos] = useState([]);
  const [campusList, setCampusList] = useState([]);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      getCycles().catch(() => []),
      getCampus().catch(() => []),
    ]).then(([cic, cam]) => {
      if (!mounted) return;
      setCiclos(Array.isArray(cic) ? cic : []);
      setCampusList(Array.isArray(cam) ? cam : []);
    });
    return () => { mounted = false; };
  }, []);

  const resolveContext = () => {
    const ciclo = ciclos.find(c => String(c.id) === String(filters.ciclo_escolar));
    const campus = campusList.find(c => String(c.id) === String(filters.id_campus));
    return {
      ciclo: ciclo ? (ciclo.name || ciclo.nombre_ciclo) : '',
      campus: campus ? campus.nombre : '',
      matricula: filters.matricula || '',
    };
  };

  const handleBuscar = () => {
    if (typeof onContextResolved === 'function') {
      onContextResolved(resolveContext());
    }
    onBuscar();
  };

  const disabled = loading || !filters.matricula || !String(filters.matricula).trim();

  return (
    <section className={styles.filtersSection}>
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Ciclo Escolar</label>
          <select
            className={styles.filterSelect}
            value={filters.ciclo_escolar || ''}
            onChange={(e) => onChange('ciclo_escolar', e.target.value)}
          >
            <option value="">Selecciona un ciclo</option>
            {ciclos.map(c => (
              <option key={c.id} value={c.id}>{c.name || c.nombre_ciclo}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Campus</label>
          <select
            className={styles.filterSelect}
            value={filters.id_campus || ''}
            onChange={(e) => onChange('id_campus', e.target.value)}
          >
            <option value="">Todos</option>
            {campusList.map(c => (
              <option key={c.id} value={c.id}>{c.nombre}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Matrícula *</label>
          <input
            type="text"
            className={styles.filterSelect}
            value={filters.matricula || ''}
            onChange={(e) => onChange('matricula', e.target.value)}
            placeholder="Ej: 20251001"
            onKeyDown={(e) => { if (e.key === 'Enter' && !disabled) handleBuscar(); }}
          />
        </div>

        <div className={styles.filterGroup} style={{ flex: '0 0 auto', minWidth: 'auto' }}>
          <label className={styles.filterLabel}>&nbsp;</label>
          <button
            type="button"
            className={styles.generateButton}
            onClick={handleBuscar}
            disabled={disabled}
          >
            {loading ? 'Buscando...' : 'Buscar Estudiante'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default FiltrosRevalidacion;
